import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, SearchX } from 'lucide-react';



import SEO from '../components/SEO';

const NotFound: React.FC = () => {
    return (
        <div className="min-h-[80vh] flex items-center justify-center bg-brand-light px-4 pt-32 pb-32">
            <SEO
                title="Sayfa Bulunamadı"
                description="Aradığınız sayfa bulunamadı. Pato Yazılım anasayfasına dönün."
                link="/404"
                noIndex={true}
            />
            <div className="text-center max-w-2xl mx-auto">
                <div className="relative inline-block mb-8">
                    <div className="absolute inset-0 bg-brand-blue/20 blur-3xl rounded-full"></div>
                    <SearchX size={120} className="text-brand-blue relative z-10 mx-auto" />
                </div>

                <h1 className="text-8xl font-bold text-brand-dark mb-4 tracking-tighter">404</h1>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
                    Oops! Kaybolmuş Gibisiniz.
                </h2>
                <p className="text-xl text-gray-700 mb-10 leading-relaxed">
                    Üzgünüz, gitmek istediğiniz sayfa silinmiş, taşınmış veya hiç var olmamış olabilir.
                    Anasayfaya dönerek yolculuğunuza devam edebilirsiniz.
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link
                        to="/"
                        className="inline-flex items-center justify-center gap-2 bg-brand-blue text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-blue-600 transition-all shadow-lg hover:shadow-brand-blue/30 hover:-translate-y-1"
                    >
                        <Home size={20} />
                        Anasayfaya Dön
                    </Link>

                    <button
                        onClick={() => window.history.back()}
                        className="inline-flex items-center justify-center gap-2 bg-white text-brand-dark border-2 border-gray-200 px-8 py-4 rounded-full font-bold text-lg hover:border-brand-blue hover:text-brand-blue transition-all"
                    >
                        <ArrowLeft size={20} />
                        Geri Dön
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
